module.exports = __webpack_public_path__ + "img/baptis-logo.9c2bd5ae.png";